module.exports = __webpack_public_path__ + "img/CorrectAnsBelowAvgTimeSmiley.dfb7e9ee.svg";